import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BiTransfer } from 'react-icons/bi';
import { LiaStarSolid, LiaTimesSolid } from 'react-icons/lia';
import { MdAccountCircle } from 'react-icons/md';
import { getToken, windowReload } from '../utils';
import Modal from '../Components/Modal';
import { LoadingMode } from '../Components/LoadingMode';
import { toast } from 'react-toastify';

function AllBidders({ content }) {
  const userToken = getToken()?.token;

  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeid, setActiveId] = useState(0);
  const { getDataById, bidUsers, setClickedBidChatUser, clickedBidChatUser } =
    content;

  console.log({ getDataById });

  useEffect(() => {
    if (bidUsers.length && clickedBidChatUser === undefined) {
      console.log(bidUsers[0], 'checking');
      setClickedBidChatUser(bidUsers[0]);
      setActiveId(bidUsers[0]?.id);
    }
  }, [bidUsers, clickedBidChatUser, setClickedBidChatUser]);

  const handleCloseTransaction = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/cx-transaction/cancel`,
        { cx_id: getDataById.id },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      toast.success(`${data.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });

      setIsOpen(false);
      windowReload();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetChartdetails = (data) => {
    setClickedBidChatUser(data);
    setActiveId(data?.id);
  };

  return (
    <>
      <div className='flex flex-col gap-4 items w-full border-hf p-6 rounded h-72 '>
        <div className='flex flex-row justify-between'>
          <h2 className='font-semibold text-p-bk'>Transaction Offers</h2>
          <button
            className='w-fit bg-f-bk shadow-l hover:bg-t-bk/80 active:bg-t-bk/70 text-p-bk py-1.5 px-4 text-xs rounded'
            onClick={() => setIsOpen(true)}
          >
            Cancel Transaction
          </button>
        </div>
        <div className='overflow-y-scroll space-y-4 h-full'>
          {' '}
          {bidUsers?.map((data, index) => (
            //  bidId === data.id ? "bg-b-mc text-p-wh"
            <div
              key={index}
              className={`shadow py-2 px-4 flex flex-row justify-between w-full rounded hover:shadow hover:bg-b-mc focus:bg-b-mc cursor-pointer ${
                activeid === data.id ? 'bg-b-mc' : 'bg-p-wh '
              }`}
              onClick={() => handleGetChartdetails(data)}
            >
              <div className='flex flex-row gap-2'>
                <span className={'text-p-bk/50 text-4xl'}>
                  <MdAccountCircle />
                </span>
                <div className='flex flex-col text-xs'>
                  <span>{data?.unique_code}</span>
                  <div className={'flex flex-row gap-4 items-center text-s-bk'}>
                    <p className='flex flex-row gap-2 items-center text-xs'>
                      Rating {data?.user?.rating}
                      <span className='text-green-500 -m-1'>
                        <LiaStarSolid />
                      </span>
                    </p>
                    <p className='flex flex-row gap-2 items-center text-xs '>
                      Order {data?.user?.trx_stats?.completed}
                      <span className='text-green-500'>{<BiTransfer />}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <p className='flex flex-col text-xs'>
                  {(data.amount * 1)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{" "}
            {getDataById?.quote_currency?.symbol}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* <button className="bg-b-mc w-fit hover:bg-b-mc/80 active:bg-b-mc/70 text-p-wh py-2 px-6 rounded-md">
            Next Transaction
          </button> */}

        {/* <div className="flex flex-row gap-2 text-s-bk border-hf border-b-mct px-4 py-4 rounded-lg">
            <span className="text-2xl text-b-mc/75">
              <RiInformationFill />
            </span>
            <div className="text-xs flex flex-col gap-7 items-end">
              <p className="text-b-mc font-light">
                An FX Selling user will receive a penalty fees if ongoing
                transaction is canceled after buying user transfers exotic
                currency into LV Holding account. This penalty will be a
                negative debit in his LV account that would be settled as part
                of his next transaction else he won't be able to do another
                transaction
              </p>
              <button className="w-fit bg-f-bk drop-shadow-lg hover:bg-t-bk/80 active:bg-t-bk/70 text-p-bk py-2 px-6 text-base rounded-md">
                Cancel Transaction
              </button>
            </div>
          </div> */}
      </div>

      <Modal open={isOpen}>
        <article className='w-[25rem] bg-p-wh shadow rounded absolute py-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
          <h2 className='text-[18px] font-semibold pb-2 mb-6 px-6 border-b-hf'>
            Cancel Transaction
          </h2>

          <span
            className='absolute items-center  top-6 right-6 text-2xl text-s-bk cursor-pointer hover:text-p-bk'
            onClick={() => setIsOpen(false)}
          >
            <LiaTimesSolid />
          </span>

          <div className='flex flex-row justify-between mb-6'>
            <p className='px-6 flex flex-col justify-between'>
              Are you sure you want to cancel this transaction? Cancelling this transaction may attract a penalty
              {getDataById?.payment?.penalty ? ' of '+(getDataById?.payment?.penalty * 1)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}{" "}
            {getDataById?.base_currency?.symbol}
            </p>
          </div>

          <div className='flex flex-row gap-6 px-6 pt-8'>
            <button
              className='py-2 bg-b-mc disabled:bg-b-mct text-p-wh relative rounded-md hover:bg-b-mc/75 focus:bg-b-mc/80 text-base px-6 w-full'
              onClick={handleCloseTransaction}
            >
              Continue
              {isLoading && <LoadingMode />}
            </button>
          </div>
        </article>
      </Modal>
    </>
  );
}

export default AllBidders;
